<template>
  <div class="viewport-gutter">
    <div class="container">
      <div class="text-4y-gray-900 pt-16 pb-16 max-w-183">
        {{ tr('pages.sales.buy.sellerNote.text') }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({})
</script>
